import React from 'react'
import AnimateHeight from 'react-animate-height'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const DropdownNotification = ({ height2, closeNotification }) => {
    const notifies = useSelector(state => state.notification.list);

    return (
        <AnimateHeight
            height={height2}
            duration={300}
            className='notification_wrap'
        >
            <div className="notification">
                <div className="notification_title">
                    <h3>Notifications</h3>
                </div>
                <div className="notification_list">
                    <div className="notification_category">
                        <button className="all active">
                            All
                        </button>
                        <button className="unread">
                            Unread
                        </button>
                        <Link to="/notifications" className='notify_view_all'
                            onClick={closeNotification}
                        >view all</Link>
                    </div>
                    <div className="earlier_list">
                        <p className="earlier_list_title">Earlier</p>
                        {[...notifies].map((notify, index) => (
                            <div className="notification_item" key={index}>
                                {notify.sender &&
                                    <div className="image_sender">
                                        <img src={notify.sender.avatarUrl} alt="" />
                                    </div>}
                                <p className={notify.seen ? "notify_content" : "notify_content unread"}>
                                    <b>{notify.sender ? <>{notify.sender.fullName} sent to you </> : "System sent to you "}</b>"{notify.content}"
                                </p>
                                <span className='seen_icon'></span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </AnimateHeight>
    )
}

export default DropdownNotification;